import { render, staticRenderFns } from "./choose-headers.vue?vue&type=template&id=df7dbfc8&"
import script from "./choose-headers.vue?vue&type=script&lang=js&"
export * from "./choose-headers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df7dbfc8')) {
      api.createRecord('df7dbfc8', component.options)
    } else {
      api.reload('df7dbfc8', component.options)
    }
    module.hot.accept("./choose-headers.vue?vue&type=template&id=df7dbfc8&", function () {
      api.rerender('df7dbfc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataImport/components/choose-headers.vue"
export default component.exports